import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {take} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Configuration} from '../models/configuration';
import {selectConfiguration} from '../store/workspace/workspace.selector';
import {ApplicationDto} from './dto/application.dto';
import {ConfigurationDto} from './dto/configuration.dto';
import {UserInfoDto} from './dto/user-info.dto';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationApiService {
  private configuration$: Observable<Configuration>;

  constructor(private http: HttpClient, private store$: Store) {
    this.configuration$ = this.store$.pipe(select(selectConfiguration));
  }

  public getEndpointUrl(): string {
    let urlEndpoint = '';
    this.configuration$.pipe(take(1)).subscribe(config => {
      urlEndpoint = `${config.userInformation.endpointUrlDra}/api`;
    });
    return urlEndpoint;
  }

  public getAppSettings(applicationId: string): Observable<ApplicationDto> {
    return this.http.get<ApplicationDto>(`${environment.apiUrl}/AppSettings/${applicationId}`);
  }

  public getConfiguration(): Observable<ConfigurationDto> {
    return this.http.get<ConfigurationDto>(`${environment.apiUrl}/Configuration`);
  }

  public sendLogInfo(applicationGuid: string) {
    const payload = {AppGuid: applicationGuid};
    return this.http.post(`${environment.apiUrl}/Log`, payload);
  }

  public getUserInfo(): Observable<UserInfoDto> {
    return this.http.get<UserInfoDto>(`${environment.apiUrl}/UserInfo`);
  }

  public updateUserInfo(userDto: Partial<UserInfoDto>): Observable<UserInfoDto> {
    return this.http.put<UserInfoDto>(`${environment.apiUrl}/UserInfo`, userDto);
  }

  public resetTestData() {
    return this.http.post(`${environment.apiUrl}/ResetTestAccount`, {});
  }
}
